import { render, staticRenderFns } from "./CodeEditorJSON.vue?vue&type=template&id=363d0fb1&scoped=true"
import script from "./CodeEditorJSON.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeEditorJSON.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CodeEditorJSON.vue?vue&type=style&index=0&id=363d0fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d0fb1",
  null
  
)

export default component.exports